﻿let CustomerSearchTable: DataTables.DataTable = null;
let SearchFieldData: any = null;
let CustomerData: any = null;

const umtInfo: number = 0;
const umtWarning: number = 1;
const umtError: number = 2;

namespace WebPortal.Default {
    export class CustomerSearchHandler {
        constructor() { this.init(); }

        private init(): void {
            $('#nav_customer_search').off().on('click', () => {
                let UserSettings = JSON.parse($("#hdf_settings").val());
                if (!SearchFieldData) {
                    Show_Status_Message({ title: "Search Preparation", message: "Loading Search Data", progress: true });
                    WebPortalHubObj.server.doSearchFieldRequest($("#hdf_se_request_param").val());
                }
                if (!!UserSettings && !UserSettings.IsSwisscomUser) {
                    if (!CustomerData) {
                        Show_Status_Message({ title: "Search Preparation", message: "Loading Search and Customer Data", progress: true });
                        WebPortalHubObj.server.doCustomerSearchRequest($("#hdf_se_request_param").val(), null);
                    }
                }
                setTimeout(() => { this.resize(); }, 500);
            });

            $('#tbl_customer_area').off().on('dblclick', 'tr', (e: JQueryEventObject) => {
                NewSessionCustomerData = CustomerSearchTable.row(e.currentTarget).data();
                NewSessionCustomerData.RequestType = nscdi_Search;
                return (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).startChecksForLoadCustomer();
            }).on('click', '.openCustomer', (e: JQueryEventObject) => {
                NewSessionCustomerData = CustomerSearchTable.row($(e.currentTarget).closest('tr')).data();
                NewSessionCustomerData.RequestType = nscdi_Search;
                return (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).startChecksForLoadCustomer();
            }).on('click', '.editCustomer', (e: JQueryEventObject) => {
                NewSessionCustomerData = CustomerSearchTable.row($(e.currentTarget).closest('tr')).data();
                NewSessionCustomerData.RequestType = nscdi_Search_edit;
                return (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).startChecksForLoadCustomer();
            });
        }

        public PrepareSearchFieldArea(_SearchFieldData: any): void {
            $("#pn_searchfield_area").empty();

            // Alle SearchField Elemente ausgeben
            if (!!_SearchFieldData && !!_SearchFieldData.SearchFields && (_SearchFieldData.SearchFields.length > 0)) {
                SearchFieldData = _SearchFieldData;
                this.AddFielsToSearchFieldArea(_SearchFieldData.SearchFields);
                $("#pn_searchfield_area")
                    .append($("<div>")
                        .attr({
                            "class": "col-xs-12 col-sm-10 col-md-10",
                        }).append($("<div>")
                            .attr({
                                "role": "alert",
                                "id": "pn_CustomerSearch_UserMessage"
                            })
                        )

                    ).append($("<div>")
                        .attr({
                            "class": "col-xs-12 col-sm-12 col-md-12"
                        })
                        .append($("<div>")
                            .attr({
                                "class": "btn-toolbar",
                                "role": "toolbar"
                            })
                            .append($("<button>")
                                .attr({
                                    "class": "btn btn-default",
                                    "id": "bt_CustomerSearch_search"
                                }).text("Search")
                            )
                            .append($("<button>")
                                .attr({
                                    "class": "btn btn-default",
                                    "id": "bt_CustomerSearch_reset"
                                }).text("Reset")
                            )
                        )
                    );
            }

            // Info: Zuteilung hier, da die Daten dynamisch erzeugt werden
            $(".customer_search_field").off().on("keyup", (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.CustomerSearch();
                }
            });

            $("#bt_CustomerSearch_reset").off().on("click", () => {
                return this.ResetCustomerSearch();
            }).on("keyup", (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.ResetCustomerSearch();
                }
            });

            $("#bt_CustomerSearch_search").off().on("click", () => {
                return this.CustomerSearch();
            }).on("keyup", (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.CustomerSearch();
                }
            });

            // Code für das Anzeige und verschwinden lassen des X bei Inputfeldern
            $('.has-clear-customer-search-field input').on("input propertychange", (e: JQueryEventObject) => {
                let visible: boolean = Boolean($(e.currentTarget).val());
                $(e.currentTarget).siblings('.clear-customer-search-field').toggleClass('hidden', !visible);
            }).trigger('propertychange');

            $('.clear-customer-search-field').off().on("click", (e: JQueryEventObject) => {
                $(e.currentTarget).siblings('input').val('')
                    .trigger('propertychange').focus();
            });

            setTimeout(() => { $("#tb_CustomerName").focus(); }, 500)

            let UserSettings = JSON.parse($("#hdf_settings").val());
            if (!!UserSettings && UserSettings.IsSwisscomUser) {
                Close_Status_Message();
            }

        }

        public PrepareCustomerArea(_CustomerData: any): void {
            //console.info(JSON.stringify(_CustomerData));

            if (!!_CustomerData && !!_CustomerData.CustomerList) {
                CustomerData = _CustomerData;
                CustomerSearchTable = $('#tbl_customer_area').DataTable(
                    {
                        "destroy": true,
                        "ordering": true,
                        "order": [[2, 'asc'], [4, 'asc']],
                        "paging": false,
                        "searching": false,
                        "info": false,
                        "dom": 'lrtip',
                        "processing": true,
                        "data": _CustomerData.CustomerList,
                        "columns": [
                            {
                                "data": null,
                                "createdCell": (cell: Node, cellData: any, rowData: any, row: number, col: number) => {
                                    (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).SetOpenEditButton(cell, cellData, rowData, row, col)
                                }
                            },
                            { "data": "ID" },
                            { "data": "V1" },
                            { "data": "V2" },
                            { "data": "V3" },
                            {
                                "data": null,
                                "createdCell": (cell: Node, cellData: any, rowData: any, row: number, col: number) => {
                                    (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).SetSecurityProperties(cell, cellData, rowData, row, col)
                                }
                            }
                        ],
                        "columnDefs": [
                            { "targets": 1, "visible": false },
                        ],
                        "responsive": true,
                        "scrollY": "100%",
                        "scrollX": false,
                        "scrollCollapse": true,
                    }
                );
            }

            this.PrepareUserMessage(_CustomerData);
            (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).ActiveSecurityProperties();
            Close_Status_Message();

            this.resize();
        }

        private AddFielsToSearchFieldArea(_List: any): void {
            for (let key in _List) {
                if (_List.hasOwnProperty(key)) {
                    const field = _List[key];
                    const inputId = "tb_" + field.FieldName;
                    const columnDiv = $("<div>").addClass("col-xs-12 col-sm-6 col-md-3");

                    const formGroup = $("<div>").addClass("form-group has-feedback has-clear-customer-search-field");

                    const label = $("<label>")
                        .addClass("text-nowrap")
                        .attr("for", inputId)
                        .text(field.FieldDescription);

                    const input = $("<input>")
                        .attr({
                            type: field.FieldType,
                            id: inputId,
                            class: "form-control customer_search_field",
                            "data-fieldname": field.FieldName,
                            placeholder: field.Placeholder,
                        });

                    const clearIcon = $("<span>")
                        .addClass("form-control-clear icon icon-022-close form-control-feedback clear-customer-search-field hidden");

                    formGroup.append(label, input, clearIcon);
                    columnDiv.append(formGroup);

                    // Nur für Hostname: spezielle Behandlung
                    if (field.FieldName.toLowerCase() === "hostname") {

                        // Dummy-E-Mail-Feld vor dem eigentlichen Feld
                        const dummyEmail = $("<input>")
                            .attr({
                                type: "text",
                                name: "fakeemail_autofill_blocker",
                                autocomplete: "email",
                                style: "opacity:0;position:absolute;top:-1000px;left:-1000px;height:0;width:0;border:0;padding:0;margin:0;"
                            });

                        formGroup.append(dummyEmail);
                    }
                    
                    $("#pn_searchfield_area").append(columnDiv);
                }
            }
        }

        private ResetCustomerSearch() {
            $(".customer_search_field").val("");
            $('.has-clear-customer-search-field input').siblings('.clear-customer-search-field').addClass("hidden");
            this.PrepareUserMessage(null);
            return false;
        }

        private CustomerSearch() {
            //console.info("CustomerSearch");
            let QueryParameterArr = {};
            let SearchList: any = $(".customer_search_field")
                .each((index: number, elem: any) => {
                    let eInput: string = $(elem).val().trim().toLowerCase();
                    if (!!eInput) {
                        let fieldname: string = $(elem).attr("data-fieldname");
                        QueryParameterArr[fieldname] = eInput;
                    }
                });
            Show_Status_Message({ title: "Search", message: "Loading Customer Data", progress: true });
            WebPortalHubObj.server.doCustomerSearchRequest($("#hdf_se_request_param").val(), QueryParameterArr);
            return false;
        }

        private PrepareUserMessage(_CustomerData: any): void {
            $("#pn_CustomerSearch_UserMessage").empty();
            $("#pn_CustomerSearch_UserMessage").removeClass();
            if (!!_CustomerData && !!_CustomerData.UserMessage) {
                let Text: string = _CustomerData.UserMessage.Text;
                let MessageType: number = _CustomerData.UserMessage.MessageType;

                $("#pn_CustomerSearch_UserMessage").html(Text);
                switch (MessageType) {
                    case umtInfo:
                        $("#pn_CustomerSearch_UserMessage").addClass("alert alert-info");
                        break;
                    case umtWarning:
                        $("#pn_CustomerSearch_UserMessage").addClass("alert alert-warning");
                        break;
                    case umtError:
                        $("#pn_CustomerSearch_UserMessage").addClass("alert alert-danger");
                        break;
                    default:
                        $("#pn_CustomerSearch_UserMessage").addClass("alert alert-info");
                        break;
                }
            }
        }

        public resize(): void {
            let MaxDivHeight = $(window).height() - (12 + $('#pn_default_navigation').height() + $('#pn_searchfield_area').height() + $('#pn_searchfield_area_delimiter').height() + 38 + 55);
            let CustomerDataTable = $($('#tbl_customer_area_wrapper').find('div.dataTables_scrollBody')[0]);
            if (!!CustomerDataTable) {
                if (MaxDivHeight > 300) {
                    CustomerDataTable.height(MaxDivHeight.toString() + "px");
                } else {
                    CustomerDataTable.height("100%");
                }
                if (!!CustomerSearchTable) {
                    // Die Tabelle wird zweimal neu ausgerichtet. Dies, da beim ersten Mal die Tabelle nicht korrekt angzeigt wird
                    setTimeout(() => { CustomerSearchTable.columns.adjust(); }, 500);
                    setTimeout(() => { CustomerSearchTable.columns.adjust(); }, 200);
                }
            }
        }
    }
}